class LWBack extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const linkAttr = this.getAttribute('link');
        const href = linkAttr ? linkAttr : "javascript:history.back()";
        const isRight = this.getAttribute('dir') === 'right';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                position: absolute;
                top: 20px;
                /* Positionering op basis van richting */
                ${isRight ? 'right: 20px;' : 'left: 20px;'}
                width: 10%;
                z-index: 20;
                pointer-events: auto;
                cursor: pointer;
            }

            .back-wrapper {
                width: 100%;
                display: flex;
                align-items: flex-start;
                transition: transform 0.3s ease;
                text-decoration: none;
                /* Draai het hele plaatje/slot om als het 'right' is */
                ${isRight ? 'transform: rotate(180deg);' : ''}
            }

            .back-wrapper:hover {
                /* Hover effect meebewegen met de richting */
                transform: ${isRight ? 'rotate(180deg) translateX(-5px)' : 'translateX(-5px)'};
            }

            ::slotted(img), ::slotted(svg) {
                width: 100%;
                height: auto;
                display: block;
                filter: drop-shadow(0 2px 10px rgba(0,0,0,0.1));
            }

            @media (max-width: 599px) {
                :host {
                    top: 20px;
                    ${isRight ? 'right: 20px;' : 'left: 20px;'}
                    width: 12%;
                }
            }

            @media (min-width: 600px) {
                :host {
                    top: 60px;
                    ${isRight ? 'right: 60px;' : 'left: 60px;'}
           
                }
            }
        </style>
        <a href="${href}" class="back-wrapper">
            <slot></slot>
        </a>
        `;
    }
}

customElements.define('lw-back', LWBack);